<template>
  <v-container class="pa-10">
    <div class="text-h5">Fale Conosco</div>
    <v-divider />
    <v-row class="pl-3 pb-6 pt-4">
      <div class="text-h7">
        Tem alguma dúvida, sugestão ou um elogio quem sabe? Fale com a gente,
        Assim que possível entraremos em contato.
      </div>
    </v-row>

    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col cols="12" md="4">
          <v-select dense
            :items="lstMotivo"
            label="Motivo do contato"
            item-text="descricao" item-value="codigo"
            outlined
            v-model="contato.motivo"
            :rules="[v => !!v || 'Campo obrigatório']"
            required
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="3">
          <v-text-field dense disabled
            v-model="contato.email"
            :rules="emailRules"
            label="E-mail"
            required
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field dense
            v-model="contato.telefone"
            label="Telefone"
            required
            outlined
            v-mask="mascaraCelular"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-text-field dense
            v-model="contato.assunto"
            label="Assunto"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-textarea dense
            v-model="contato.mensagem"
            label="Mensagem"
            required
            outlined
            :rules="[v => !!v || 'Campo obrigatório']"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row class="text-end">
        <v-col cols="12" md="6">
          <v-btn :disabled="!valid" color="primary" @click="enviarEmail">Enviar</v-btn>
        </v-col>
      </v-row>

    </v-form>

    <v-overlay :value="isLoading" >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-dialog
      v-model="dialog"
      max-width="300" 
    >
      <v-card>
        <v-card-title>
          Sucesso
        </v-card-title>
        <v-card-text >
          <p> Sua mensagem foi enviada com sucesso.</p>
          <p>Retornaremos assim que possível.</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      right
      top
      color="error"
      v-model="snackbar"
      :timeout="6000"
    >
      Ocorreu um erro, favor contate o administrador.
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon dark> mdi-colse </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import Contato from '../../models/contato';
  import Enum from '../../utils/enums.json';
  import { mapActions, mapState } from 'vuex';

  export default {
    data: () => ({
      lstMotivo: Enum.motivoContato,
      contato: new Contato(),
      emailRules: [
        (v) => !!v || 'Este campo é obrigatório',
        (v) => /.+@.+\..+/.test(v) || 'Você deve inserir um email válido',
      ],
      mascaraCelular: '(##) #####-####',
      valid: false,
      dialog: false,
      snackbar: false
    }),

    computed: {
      ...mapState('contato', ['isLoading']),
    },

    created() {
      this.initialize();
    },

    

    methods: {
      ...mapActions('contato', ['enviar']),
      async enviarEmail() {
        if(this.$refs.form.validate()){
          const resp = await this.enviar(this.contato);
        
          if(resp.status === 200){
            this.dialog = true;
            this.limparCampos();
            this.valid = true;
            this.$refs.form.resetValidation()
          }else{
            this.$refs.form.resetValidation()
            this.snackbar = true;
          }
        }
      },

      initialize() {
        let userData = JSON.parse(localStorage.getItem('auth.currentUser'));
        this.contato.email = userData.email;
      },

      limparCampos(){
        this.contato.motivo = ''
        this.contato.assunto = ''
        this.contato.mensagem = ''
        this.contato.telefone = ''
      }
    },
  };
</script>
